<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const emit = defineEmits([
  'add',
  'import',
  'export',
  'duplicates',
  'deleteAll',
]);

const { t } = useI18n();
const store = useStore();
const currentRole = computed(() => store.getters.getCurrentRole);
const isAdmin = computed(() => currentRole.value === 'administrator');

const allMenuItems = [
  {
    label: t('CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.ADD_CONTACT'),
    action: 'add',
    value: 'add',
    icon: 'i-lucide-plus',
  },
  {
    label: t('CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.EXPORT_CONTACT'),
    action: 'export',
    value: 'export',
    icon: 'i-lucide-upload',
    adminOnly: true,
  },
  {
    label: t('CONTACTS_LAYOUT.HEADER.ACTIONS.CONTACT_CREATION.IMPORT_CONTACT'),
    action: 'import',
    value: 'import',
    icon: 'i-lucide-download',
  },
  {
    label: 'Detectar Duplicatas',
    action: 'duplicates',
    value: 'duplicates',
    icon: 'i-lucide-copy-x',
    adminOnly: true,
  },
  {
    label: t('CONTACTS_LAYOUT.HEADER.ACTIONS.DELETE_ALL_CONTACTS.TITLE'),
    action: 'deleteAll',
    value: 'deleteAll',
    icon: 'i-lucide-trash-2',
    adminOnly: true,
  },
];
const contactMenuItems = computed(() =>
  isAdmin.value ? allMenuItems : allMenuItems.filter(i => !i.adminOnly)
);
const showActionsDropdown = ref(false);

const handleContactAction = ({ action }) => {
  if (action === 'add') {
    emit('add');
  } else if (action === 'import') {
    emit('import');
  } else if (action === 'export') {
    emit('export');
  } else if (action === 'duplicates') {
    emit('duplicates');
  } else if (action === 'deleteAll') {
    emit('deleteAll');
  }
};
</script>

<template>
  <div v-on-clickaway="() => (showActionsDropdown = false)" class="relative">
    <Button
      icon="i-lucide-ellipsis-vertical"
      color="slate"
      variant="ghost"
      size="sm"
      :class="showActionsDropdown ? 'bg-n-alpha-2' : ''"
      @click="showActionsDropdown = !showActionsDropdown"
    />
    <DropdownMenu
      v-if="showActionsDropdown"
      :menu-items="contactMenuItems"
      class="ltr:right-0 rtl:left-0 mt-1 w-52 top-full"
      @action="handleContactAction($event)"
    />
  </div>
</template>
